import { toMatchSnapshot } from "jest-snapshot";
import { type Report } from "../../reporter";
import {
	type MatcherContext,
	type MatcherResult,
	type MaybeAsyncCallback,
	codeframe,
	diverge,
} from "../utils";
import { getResults } from "./get-results";

function createMatcher(): MaybeAsyncCallback<Report | string, [Array<string | object>]> {
	function toMatchCodeframe(
		this: MatcherContext,
		actual: Report | string,
		...rest: Array<string | object>
	): MatcherResult {
		/* istanbul ignore next: cant figure out when this would be unset */
		const filename = this.testPath ?? "inline";
		const results = getResults(filename, actual);
		const snapshot = codeframe(results).replaceAll(/\s+$/gm, "");

		/* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call --
		 * the implementation works but the declarations doesn't allow it */
		return (toMatchSnapshot as any).call(this, snapshot, ...rest);
	}
	return diverge(toMatchCodeframe);
}

export { createMatcher as toMatchCodeframe };
